"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var ObjectForm_1 = __importStar(require("../ObjectForm"));
var utils_1 = require("../../utils");
var styles = {
    upload: { width: "100%" },
};
var ASSET_TYPES = [
    { value: "image", label: "Image" },
    { value: "audio", label: "Audio" },
    { value: "video", label: "Video" },
    { value: "video_text_track", label: "Video Text Track" },
    { value: "pdf", label: "PDF" },
];
var fileGetValueFromEvent = function (e) { return e.file; };
var showUploadList = { showRemoveIcon: false };
var AssetForm = function (props) {
    var objectForm = (0, ObjectForm_1.useObjectForm)(props);
    return react_1.default.createElement(ObjectForm_1.default, __assign({ objectForm: objectForm }, props),
        react_1.default.createElement(antd_1.Row, { gutter: 12 },
            react_1.default.createElement(antd_1.Col, { flex: 1 },
                react_1.default.createElement(antd_1.Form.Item, { name: "asset_type", label: "Asset Type", rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Select, { options: ASSET_TYPES }))),
            react_1.default.createElement(antd_1.Col, { flex: 2 },
                react_1.default.createElement(antd_1.Form.Item, { name: "file", label: "File", valuePropName: "file", getValueFromEvent: fileGetValueFromEvent, rules: ObjectForm_1.RULES_REQUIRED_BASIC },
                    react_1.default.createElement(antd_1.Upload, { maxCount: 1, showUploadList: showUploadList, beforeUpload: utils_1.getFalse, style: styles.upload },
                        react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.UploadOutlined, null) }, "Click to Upload"))))));
};
exports.default = AssetForm;
